"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { MapPin, Clock, DollarSign } from "lucide-react";
function ToursResultsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-2xl bg-white/5 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-[#B7C2CE] mb-4">Failed to load experiences.</p>
        <Button onClick={() => window.location.reload()}>Retry</Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-[#B7C2CE]">No experiences available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group overflow-hidden border border-white/8 bg-[#111827] rounded-2xl transition-all duration-[var(--duration-medium)] hover:shadow-medium hover:-translate-y-1 hover:border-[#2DD4BF]/30">
          {post.featuredImage && <div className="relative h-64 overflow-hidden after:absolute after:inset-0 after:bg-linear-to-t after:from-[#0B0F14]/80 after:to-transparent after:opacity-0 group-hover:after:opacity-100 after:transition-opacity after:duration-500">
              <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            </div>}
          
          <CardContent className="p-5 sm:p-6 space-y-4">
            <h3 className="text-xl font-display font-bold text-[#FFFFFF] line-clamp-2 leading-tight">
              {post.customFields?.name || post.title}
            </h3>
            
            {post.customFields?.description && <p className="text-sm text-[#EAF0F6] line-clamp-3 leading-relaxed">
                {post.customFields.description}
              </p>}

            <div className="space-y-3 pt-2">
              {post.customFields?.duration && <div className="flex items-center gap-2 text-sm text-[#B7C2CE]">
                  <Clock className="size-4 text-[#2DD4BF]" />
                  <span>{post.customFields.duration}</span>
                </div>}

              {post.customFields?.location && <div className="flex items-center gap-2 text-sm text-[#B7C2CE]">
                  <MapPin className="size-4 text-[#2DD4BF]" />
                  <span>{post.customFields.location}</span>
                </div>}

              {post.customFields?.price !== undefined && <div className="flex items-center gap-2 text-lg font-semibold pt-1">
                  <DollarSign className="size-5 text-[#2DD4BF]" />
                  <span className="text-white font-bold">${post.customFields.price}</span>
                  <span className="text-xs text-[#B7C2CE] font-normal uppercase tracking-wider">per person</span>
                </div>}
            </div>
          </CardContent>

          <CardFooter className="px-6 pb-6 pt-0">
            <Button asChild className="w-full bg-[#2DD4BF] hover:bg-[#2DD4BF]/90 text-[#0B0F14] font-bold rounded-lg transition-colors">
              <Link to={post.link || "#"}>View Experience</Link>
            </Button>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function ToursResults() {
  return <section id="toursresults" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0F14]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-6">
            Exclusive Experiences
          </h2>
          <p className="text-lg text-[#B7C2CE] max-w-2xl mx-auto">
            Discover curated eco-luxury adventures in the heart of Riviera Maya
          </p>
        </div>

        <PostsProvider postType="experience" wp_query={{
        per_page: 9,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "link", "meta", "_embedded", "_links.wp:featuredmedia"]}>
          <ToursResultsConsumer />
        </PostsProvider>
      </div>
    </section>;
}